import './index.css';
import '@nemuru-eng/providers/index.css';

import { setCredentials } from '@nemuru-eng/js-api-client';
import { AuthProvider } from '@nemuru-eng/providers';
import ReactDOM from 'react-dom';

import { ENV_COOKIE_LOGIN_NAME, ENV_ENV } from './config/envVars';
import { Routes } from './Routes';
import * as serviceWorker from './serviceWorker';

import('./style/helpers/index.scss');
import('./style/global.scss');
import('./style/main.scss');

ReactDOM.render(
  <AuthProvider
    env={ENV_ENV}
    storageKey={ENV_COOKIE_LOGIN_NAME}
    setCredentialsCallback={setCredentials}
    enableAutoLogout
  >
    <Routes />
  </AuthProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
export { LANGUAGES } from './config/languages';
